import apis from "../../core/apis.js";

class RoleResource {
  constructor($resource) {
    "ngInject";
    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.role).get(options);
  }
}

export default RoleResource;



// WEBPACK FOOTER //
// ./src/resources/role/role.resource.js